module.exports = __webpack_public_path__ + "img/Lisa.0c3ae448.jpeg";